/**
 * (c) 2026, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */

// For landscape mobile screen sizes.
export const shortScreenHeightBreakpoint = "@media (max-height: 700px)";
